import React from 'react';
import lazyGettext from 'js-utils/lazy-gettext';

import Dialog from 'eventbrite_design_system/dialog/Dialog';
import {
    LINKED_ACCOUNTS_SUCCESS_MESSAGE,
    LINKED_ACCOUNTS_SUCCESS_TITLE,
} from '../constants';

const LinkedAccountDialog = ({ showDialog, onCloseDialog }) => (
    <div className="eds-g-cell eds-g-cell-12-12">
        <div className="eds-align--center">
            <Dialog
                isShown={showDialog}
                message={LINKED_ACCOUNTS_SUCCESS_MESSAGE}
                title={LINKED_ACCOUNTS_SUCCESS_TITLE}
                primaryText={lazyGettext('Close')}
                primaryType="link"
                onPrimaryAction={onCloseDialog}
                onClose={onCloseDialog}
                onClickOutside={onCloseDialog}
            />
        </div>
    </div>
);

export default LinkedAccountDialog;
